module.exports = __webpack_public_path__ + "img/businessplusicon.a36f1cfc.svg";